import React, { useState } from "react";
import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { setAppError } from "../../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { CgSpinner } from "react-icons/cg";
import nodeinstance from "../../../../../nodeInstance";
import UploadFilePopUp from "../../../../../ReusableComponents/UploadFile/uplaodFile";
import { unstable_HistoryRouter, useNavigate } from "react-router-dom";
import UploadFilePopUp_New from "../../../../../ReusableComponents/UploadFile/UploadFileNew";
import UploadFilePopUp_New_Iqama from "../../../../../ReusableComponents/UploadFile/uploadFileNewIqama";

export default function ListAtmPayRollDetailsUpdate({
  token,
  titles = [],
  list = [],
  loading,
  updateData,
  setIndex,
}) {
  const [Popup, setPopUp] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [searchWords, setSearchWords] = useState([]);

  const dispatch = useDispatch();

  const downloadFile = async () => {
    setDownloadLoading(true);
    try {
      const response = await nodeinstance.get(`/atm-payroll/downloadBank`, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Bank_Details`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      setDownloadLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };
  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(list?.data || []);

  const apiCall = () => {
    updateData("123654");
    setIndex(2);
  };
  const SuccessapiCall = () => {
    updateData("123654");
    // setIndex(2);
  }
  const navigate = useNavigate();

  return (
    <>
      <div className="flex-wrap  gap-2 w-full items-center flex flex-row-reverse">
        <button
          className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
          onClick={() => {
            navigate(`/dashboard/fin-payroll-category/`);
          }}
        >
          <p>Change PayRoll Category</p>
        </button>
        <button
          className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
          onClick={() => setPopUp(true)}
          disabled={downloadLoading || list?.isLoading}
        >
          <p>Upload Bank details</p>
          {downloadLoading && <CgSpinner className="animate-spin" />}
        </button>
        <button
          className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
          onClick={() => downloadFile()}
          disabled={currentList.length < 0 }
        >
          <p>Download Template</p>
          {downloadLoading && <CgSpinner className="animate-spin" />}
        </button>
        <Search
          searchKey={["employee_id", "visa_reference_number", "border_number"]}
          setSearchWords={setSearchWords}
        />
      </div>
      <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
      <CountPerPage />
      <div className="relative bg-white">
        <div className="overflow-x-auto max-h-[70vh]">
          <div className="sticky top-0 z-10 bg-white min-w-[3050px]">
            <div className="grid grid-cols-table-atm-payroll-details-update gap-5 p-6 text-center">
              {titles.map((t, index) => (
                <p key={index} className="font-semibold uppercase">
                  {t}
                </p>
              ))}
            </div>
          </div>
          <div className="grid grid-cols-table-atm-payroll-details-update gap-5 p-6 bg-white text-center">
            {list?.isLoading && <LoadingWithLable className="col-span-full" />}
            {!list?.isLoading && <NoDataFound />}
            {!list?.isLoading &&
              currentList.map((list, index) => (
                <React.Fragment key={index}>
                  <PaginationIndex index={index} />
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.employee_id || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.name || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.client || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.visa_provider || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.iqama_number || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.iqama_expiry_date_g || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.iqama_expiry_date_h || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.mobile_number || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.payroll_category || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.fees || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.payment_status || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.bank_name || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.account_number || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.iban_number || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.atm_card_number || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.atm_card_expiry || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.atm_status || "-"}
                    />
                  </p>
                  <hr
                    className={`border-[1.5px] border-slate-100  w-full col-span-full`}
                  />
                </React.Fragment>
              ))}
          </div>
        </div>
      </div>
      <Pagination />

      {Popup ? (
        <UploadFilePopUp_New_Iqama
          PopUp={Popup}
          setPopUp={setPopUp}
          title={"Upload Bank details"}
          url={"/atm-payroll/uploadBank"}
          callBack={apiCall}
          SuccessapiCall = {SuccessapiCall}
          token={token}
        />
      ) : (
        ""
      )}
    </>
  );
}
